import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const StyledSpinner = styled.svg`
  animation: rotate 2s linear infinite;
  margin: ${({ centered }) => (centered ? '0' : '-25px 0 0 -25px')};
  width: 50px;
  height: 50px;

  & .path {
    stroke: #2e4787;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`

const OverlaySpinner = ({
  width, height, zIndex, active, style, centered = false,
}) => {
  const innerStyle = useMemo(() => ({
    position: 'absolute',
    width: width || '100%',
    background: '#ffffff',
    opacity: 0.6,
    height: height || '100%',
    zIndex: zIndex || 11,
    ...style,
  }), [height, style, width, zIndex])

  if (!active) {
    return null
  }

  return (
    <Box
      justify="center"
      align="center"
      round="4px"
      style={innerStyle}
    >
      <StyledSpinner viewBox="0 0 50 50" centered={centered}>
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
        />
      </StyledSpinner>
    </Box>
  )
}

export default React.memo(OverlaySpinner)
